export default __webpack_public_path__ + "static/media/masLogo.75ab78e9.svg";